// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-Xft","top":"styles_top__1lXPh","left":"styles_left__2seNs","description":"styles_description__C_Tf7"};